
import React from 'react'
import { InputText } from 'primereact/inputtext'
import { Dropdown } from 'primereact/dropdown'
import { Button } from 'primereact/button'
import { Toolbar } from 'primereact/toolbar'

interface CinemaFiltersProps {
    searchQuery: string
    setSearchQuery: (value: string) => void
    selectedGenre: string | null
    setSelectedGenre: (value: string | null) => void
    selectedYear: string | null
    setSelectedYear: (value: string | null) => void
    selectedRating: string | null
    setSelectedRating: (value: string | null) => void
    setFirst: (value: number) => void
}

const CinemaFilters: React.FC<CinemaFiltersProps> = ({
    searchQuery,
    setSearchQuery,
    selectedGenre,
    setSelectedGenre,
    selectedYear,
    setSelectedYear,
    selectedRating,
    setSelectedRating,
    setFirst
}) => {
    const genres = [
        { label: 'All Genres', value: null },
        { label: 'Action Thriller', value: 'Action Thriller' },
        { label: 'Historical Drama', value: 'Historical Drama' },
        { label: 'Action Comedy', value: 'Action Comedy' },
        { label: 'Action Drama', value: 'Action Drama' },
        { label: 'Epic Fantasy', value: 'Epic Fantasy' }
    ]

    const years = [
        { label: 'All Years', value: null },
        { label: '2023', value: '2023' },
        { label: '2022', value: '2022' },
        { label: '2021', value: '2021' },
        { label: '2015', value: '2015' }
    ]

    const ratings = [
        { label: 'All Ratings', value: null },
        { label: '8.0+', value: '8' },
        { label: '7.0+', value: '7' },
        { label: '6.0+', value: '6' }
    ]

    const startContent = (
        <React.Fragment>
            <span className="p-input-icon-left mr-2 w-full md:w-auto relative">
                <i className="pi pi-search text-gray-400 absolute" style={{ top: '50%', marginTop: 0, transform: 'translateY(-50%)', left: '1rem', fontSize: '1rem' }} />
                <InputText
                    placeholder="Search movies..."
                    value={searchQuery}
                    onChange={(e) => { setFirst(0); setSearchQuery(e.target.value) }}
                    className="border-none bg-gray-800 text-white w-full md:w-20rem border-round-3xl shadow-1 focus:shadow-3 transition-all transition-duration-200"
                    style={{ padding: '0.75rem 0.75rem 0.75rem 3rem' }}
                />
            </span>
        </React.Fragment>
    );

    const centerContent = (
        <div className="flex flex-wrap gap-2 justify-content-center align-items-center">
            <Dropdown
                value={selectedGenre}
                options={genres}
                onChange={(e) => { setFirst(0); setSelectedGenre(e.value) }}
                placeholder="Genre"
                showClear
                variant="filled"
                className="border-none bg-gray-800 border-round-xl w-full md:w-12rem shadow-1 hover:bg-gray-700 transition-colors transition-duration-200"
                panelClassName="cinema-dropdown-panel"
                pt={{
                    root: { className: 'align-items-center' },
                    input: { className: 'text-white font-medium p-3' },
                    trigger: { className: 'text-gray-400' },
                    clearIcon: { className: 'text-gray-400 mr-2 flex align-items-center' },
                }}
            />
            <Dropdown
                value={selectedYear}
                options={years}
                onChange={(e) => { setFirst(0); setSelectedYear(e.value) }}
                placeholder="Year"
                showClear
                variant="filled"
                className="border-none bg-gray-800 border-round-xl w-full md:w-14rem shadow-1 hover:bg-gray-700 transition-colors transition-duration-200"
                panelClassName="cinema-dropdown-panel"
                pt={{
                    root: { className: 'align-items-center' },
                    input: { className: 'text-white font-medium p-3' },
                    trigger: { className: 'text-gray-400' },
                    clearIcon: { className: 'text-gray-400 mr-2 flex align-items-center' },
                }}
            />
            <Dropdown
                value={selectedRating}
                options={ratings}
                onChange={(e) => { setFirst(0); setSelectedRating(e.value) }}
                placeholder="Rating"
                showClear
                variant="filled"
                className="border-none bg-gray-800 border-round-xl w-full md:w-14rem shadow-1 hover:bg-gray-700 transition-colors transition-duration-200"
                panelClassName="cinema-dropdown-panel"
                pt={{
                    root: { className: 'align-items-center' },
                    input: { className: 'text-white font-medium p-3' },
                    trigger: { className: 'text-gray-400' },
                    clearIcon: { className: 'text-gray-400 mr-2 flex align-items-center' },
                }}
            />
        </div>
    );

    const endContent = (
        <Button
            label="Clear Filters"
            icon="pi pi-filter-slash"
            className="p-button-text text-orange-400 hover:text-orange-300 hover:bg-gray-800 border-round-3xl font-bold px-4 transition-all transition-duration-200 flex align-items-center gap-2"
            onClick={() => {
                setSearchQuery('')
                setSelectedGenre(null)
                setSelectedYear(null)
                setSelectedRating(null)
                setFirst(0)
            }}
        />
    );

    return (
        <Toolbar
            start={startContent}
            center={centerContent}
            end={endContent}
            className="cinema-filters border-none border-round-3xl mb-5 p-3 flex flex-column md:flex-row gap-3 shadow-4"
            style={{ borderRadius: '24px', background: 'rgba(30, 41, 59, 0.6)' }}
        />
    )
}

export default CinemaFilters
